import React from 'react';
import LegalLayout from './LegalLayout';

const PolitiqueConfidentialite = () => (
  <LegalLayout title="Politique de confidentialité" lastUpdated="01/10/2025">
    <h2>1. Responsable du traitement</h2>
    <p>Le responsable du traitement des données personnelles collectées sur ce site est :</p>
    <p>
      <strong>SARL Eco Casse</strong><br />
      1 Rue René Koechlin<br />
      67150 Gerstheim – France
    </p>
    <p>
      Téléphone : 03 88 66 13 38<br />
      E-mail : <a href="mailto:ecocasse.careco67@gmail.com">ecocasse.careco67@gmail.com</a>
    </p>

    <h2>2. Données collectées</h2>
    <p>Nous pouvons collecter les données suivantes :</p>
    <ul>
      <li>Nom et prénom ;</li>
      <li>Adresse e-mail ;</li>
      <li>Numéro de téléphone ;</li>
      <li>Immatriculation ou informations relatives au véhicule ;</li>
      <li>Message transmis via les formulaires de contact ;</li>
      <li>Données de navigation et statistiques de visite du site ;</li>
      <li>Adresse IP publique, uniquement après votre consentement à la mesure d’audience ;</li>
      <li>Adresse IP et informations techniques de connexion.</li>
    </ul>

    <h2>3. Finalités du traitement</h2>
    <p>Les données personnelles sont collectées afin de :</p>
    <ul>
      <li>Répondre aux demandes de contact et de devis ;</li>
      <li>Rechercher des pièces détachées ;</li>
      <li>Assurer le suivi des demandes clients ;</li>
      <li>Gérer la relation commerciale ;</li>
      <li>Améliorer le fonctionnement et la sécurité du site ;</li>
      <li>Réaliser des statistiques de fréquentation après recueil de votre consentement.</li>
    </ul>

    <h2>4. Base légale des traitements</h2>
    <p>Les traitements reposent sur :</p>
    <ul>
      <li>Votre consentement lorsque celui-ci est requis ;</li>
      <li>L'exécution de mesures précontractuelles à votre demande ;</li>
      <li>L'exécution d'un contrat ;</li>
      <li>L'intérêt légitime de SARL Eco Casse pour la gestion et la sécurisation de son activité.</li>
    </ul>

    <h2>5. Destinataires des données</h2>
    <p>Les données collectées sont destinées exclusivement à SARL Eco Casse.</p>
    <p>Certaines données peuvent être transmises à des prestataires techniques intervenant pour :</p>
    <ul>
      <li>L'hébergement du site ;</li>
      <li>La maintenance informatique ;</li>
      <li>Les outils statistiques ;</li>
      <li>Les services de messagerie.</li>
    </ul>
    <p>Ces prestataires agissent conformément à la réglementation applicable en matière de protection des données.</p>

    <h2>6. Durée de conservation</h2>
    <p>Les données sont conservées pendant une durée limitée :</p>
    <ul>
      <li>Demandes de contact : jusqu'à 3 ans après le dernier échange ;</li>
      <li>Données clients : pendant la durée de la relation commerciale puis selon les obligations légales applicables ;</li>
      <li>Statistiques de fréquentation et adresse IP publique : 30 jours.</li>
      <li>Cookies : conformément à la durée indiquée dans la Politique de gestion des cookies.</li>
    </ul>

    <h2>7. Sécurité des données</h2>
    <p>
      SARL Eco Casse met en œuvre des mesures techniques et organisationnelles appropriées afin de protéger les données personnelles contre toute perte, accès non autorisé, divulgation ou altération.
    </p>

    <h2>8. Vos droits</h2>
    <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
    <ul>
      <li>Droit d'accès ;</li>
      <li>Droit de rectification ;</li>
      <li>Droit d'effacement ;</li>
      <li>Droit d'opposition ;</li>
      <li>Droit à la limitation du traitement ;</li>
      <li>Droit à la portabilité des données ;</li>
      <li>Droit de retirer votre consentement à tout moment lorsque le traitement repose sur celui-ci.</li>
    </ul>
    <p>Pour exercer ces droits, vous pouvez contacter :</p>
    <p>
      <strong>SARL Eco Casse</strong><br />
      E-mail : <a href="mailto:ecocasse.careco67@gmail.com">ecocasse.careco67@gmail.com</a>
    </p>
    <p>Une pièce d'identité pourra être demandée en cas de doute raisonnable sur l'identité du demandeur.</p>

    <h2>9. Réclamation</h2>
    <p>Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la :</p>
    <p>
      <strong>CNIL</strong><br />
      3 Place de Fontenoy<br />
      TSA 80715<br />
      75334 PARIS CEDEX 07<br />
      <a href="http://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
    </p>

    <h2>10. Modification de la présente politique</h2>
    <p>
      SARL Eco Casse se réserve le droit de modifier la présente Politique de confidentialité à tout moment afin de tenir compte des évolutions légales, réglementaires ou techniques.
    </p>
  </LegalLayout>
);

export default PolitiqueConfidentialite;
